const indexItems = [
  { title: '2026暑期档观影指南', desc: '最新大片一网打尽，暑期观影不再迷茫', icon: 'ri-movie-2-line', count: '15部' },
  { title: '国产高分悬疑剧合集', desc: '烧脑剧情与精湛演技的完美碰撞', icon: 'ri-search-eye-line', count: '12部' },
  { title: '治愈系动漫精选', desc: '温暖人心的动画作品，治愈每一个日常', icon: 'ri-heart-line', count: '20部' },
  { title: '经典港片回顾', desc: '那些年我们追过的香港电影黄金时代', icon: 'ri-film-line', count: '30部' },
  { title: '美剧高分必看榜', desc: '从权游到绝命毒师，口碑神剧一网打尽', icon: 'ri-tv-2-line', count: '18部' },
  { title: '自然纪录片精选', desc: '足不出户，领略地球最震撼的自然奇观', icon: 'ri-earth-line', count: '10部' },
  { title: '动作片爽片大合集', desc: '肾上腺素拉满，从头燃到尾的观影体验', icon: 'ri-fire-line', count: '25部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          按主题精心整理，快速找到你感兴趣的内容
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-lg border border-background-200/60 p-5 hover:border-primary-200 transition-colors group cursor-pointer flex items-start gap-4 ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 self-center">
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}